import { render, staticRenderFns } from "./KnowledgeBaseArchive.vue?vue&type=template&id=08ea7cd0&scoped=true"
import script from "./KnowledgeBaseArchive.vue?vue&type=script&lang=js"
export * from "./KnowledgeBaseArchive.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeBaseArchive.vue?vue&type=style&index=0&id=08ea7cd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ea7cd0",
  null
  
)

export default component.exports